import React, { useContext, useState } from 'react'
import { UserContext } from '../../../Context/User'
import { StoresContext } from '../../../Context/Stores'
import { API_URL, fetchCfg } from '../../../../config'
import SVG from '../../../SVG'
import Error from '../../../Error'
import Plausible from '../../../../Plausible-dummy'

const { trackEvent } = Plausible()

const ProductOptionsV2DownloadAsync = () => {
  const user = useContext(UserContext)
  const storesCtx = useContext(StoresContext)
  const { store, channel } = storesCtx

  const [waiting, setWaiting] = useState(false)
  const [error, setError] = useState(null)
  const [message, setMessage] = useState()

  const handleSubmit = async (e) => {
    e.preventDefault()
  }

  const runTool = async () => {
    setWaiting(true)
    trackEvent('V2 Product Options download')
    await createFile()
    setWaiting(false)
  }

  const createFile = async () => {
    setError(null)
    try {
      const res = await fetch(
        `${API_URL}/${store.bc_hash}/${channel.id}/v2/product-options/export/async`,
        {
          ...fetchCfg(user.csrfToken),
          method: 'post',
        }
      )
      if (res.status === 204) {
        setError('No product reviews found')
        return
      }
      const json = await res.json()
      console.log(json)
      setMessage(json.message)
    } catch (err) {
      setError('Something went wrong')
    }
  }

  const disabled = !user.authenticated || !store.bc_hash

  return (
    <div className="download">
      <div className="flex-1 border-b border-gray-200 mb-4">
        <h5 className="text-3xl leading-6 font-semibold text-gray-900 flex items-center mt-0">
          <span className="text-indigo-600">
            <SVG name="options" size={54} lineWidth={1.5} />
          </span>
          <div className="pl-2 flex items-end">V2 Product Options</div>
          <span className="ml-2 px-1 py-0.5 text-sm text-black bg-yellow-200 rounded-md border border-yellow-300">
            BETA
          </span>
        </h5>
      </div>

      <form method="post" action="#" onSubmit={handleSubmit}>
        {error && <Error msg={error} />}

        {message ? (
          <div className="my-6 px-6 pt-4 pb-6 text-sm bg-green-50 rounded-md max-w-[500px]">
            <h2 className="text-green-900">
              Generating download file
              <span className="text-green-800 animate-pulse">...</span>
            </h2>
            <p>
              You will be notified by email when your file is ready for
              download.
            </p>
            <p>
              Depending on how many products and options you have, this process
              can take a relatively long time. Go catch up on email or take a
              friend out to lunch. ☕️
            </p>
          </div>
        ) : (
          <div className="mt-2">
            <span className="block w-full py-4">
              <button
                onClick={runTool}
                disabled={disabled}
                type="button"
                className={`flex items-center justify-center py-2 px-4 border border-transparent text-lg font-medium rounded-md text-white ${
                  disabled ? 'bg-gray-500' : 'bg-blue-600'
                } ${
                  !disabled && 'hover:bg-blue-500'
                } focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition duration-150 ease-in-out`}
              >
                {waiting ? (
                  <SVG name="spinner" size={32} />
                ) : (
                  <SVG name="download" size={32} lineWidth={1} />
                )}
                <div className="ml-2">Download</div>
              </button>
            </span>
          </div>
        )}
      </form>
    </div>
  )
}

export default ProductOptionsV2DownloadAsync
